import { render } from "./LimitationTD.vue?vue&type=template&id=56061b7c"
import script from "./LimitationTD.vue?vue&type=script&lang=js"
export * from "./LimitationTD.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__